// Aktuelle URL abrufen
var currentURL = window.location.href;

// Array mit den zu überprüfenden Pfaden
var pathsToCheck = [ '/cart', '/checkout'];

// Funktion zur Überprüfung der Pfade
function checkURLPath() {
  for (var i = 0; i < pathsToCheck.length; i++) {
    if (currentURL.indexOf(pathsToCheck[i]) != -1) {
      // Wenn ein passender Pfad gefunden wurde, zur Startseite weiterleiten
      window.location.href = '/';
      return;
    }
  }
}

// Die Funktion ausführen, wenn die Seite geladen wird
window.addEventListener('load', checkURLPath);